import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
import 'quasar/src/css/index.sass'
import 'quasar/src/css/flex-addon.sass'
import '../scss/app.scss'

import App from './App.vue'
import { initSentry } from '@wsp-nz-packages/sentry-vue'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration.js'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore.js'
import relativeTime from 'dayjs/plugin/relativeTime.js'
import isBetween from 'dayjs/plugin/isBetween.js'
import advancedFormat from 'dayjs/plugin/advancedFormat.js'
import localizedFormat from 'dayjs/plugin/localizedFormat.js'
import customParseFormat from 'dayjs/plugin/customParseFormat.js'
import utc from 'dayjs/plugin/utc.js'
import weekOfYear from 'dayjs/plugin/weekOfYear.js'
import createRouter from 'src/router/index.js'
import { Quasar, Notify, Loading, Dialog } from 'quasar'
import { appVersion, sentryDsn, appUrl, isDev } from 'src/consts.js'
import { useAuthStore } from 'src/stores/authStore.js'
import { trans } from 'src/utils/i18n.js'
import { useAppStore } from 'src/stores/appStore.js'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { automount } from './globalComponents.js'

// Configure dayjs and required extensions
window.dayjs = dayjs
window.dayjs.extend(duration)
window.dayjs.extend(relativeTime)
window.dayjs.extend(isBetween)
window.dayjs.extend(advancedFormat)
window.dayjs.extend(localizedFormat)
window.dayjs.extend(customParseFormat)
window.dayjs.extend(utc)
window.dayjs.extend(weekOfYear)
window.dayjs.extend(isSameOrBefore)

if (!appUrl) {
    throw new Error('VITE_API_URL is not set. Please make sure this is set in your .env file')
}

const app = createApp(App)
automount(app)

const pinia = createPinia()
app.use(pinia)

const appStore = useAppStore()
if (appStore.preferences.app_version != appVersion) {
    appStore.resetPreferences()
}

app.use(Quasar, {
    config: { dark: appStore.preferences.dark_mode },
    plugins: {
        Notify,
        Dialog,
        Loading,
    },
})

// i18n setup
app.config.globalProperties.$t = trans
window.trans = trans

const authStore = useAuthStore()
await authStore.refreshMyDetails()

const router = createRouter()
app.use(router)

if (!isDev) initSentry(app, sentryDsn)

app.mount('#app')

document.body.removeChild(document.getElementById('preloader'))
